module.exports = __webpack_public_path__ + "static/media/96fd4fb4-75db-412f-986d-d65380ee0ccf.32c9795a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/96fd4fb4-75db-412f-986d-d65380ee0ccf.woff
// module id = 100
// module chunks = 0